module.exports = __webpack_public_path__ + "static/media/calendar.3c9f79d7.svg";